(function () {
    'use strict';

    run.admin.parts.rackootFolders = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const rootElement = document.getElementById('rackoots_root');
        const folders = document.querySelectorAll('#rackoots_nav .rackoots_folder');

        if (folders == null) {
            return;
        }

        attachSortableToRoot();
        attachEventDragOverToRoot();
        attachEventDragLeaveToRoot();
        attachEventDragDropToRoot();

        function toggleOpen(el)
        {
            el.classList.toggle('open');
            saveFoldersOpenStatus();
        }

        if (folders.length > 0) {
            for (let i = 0; i < folders.length; i++) {
                const toggler = folders[i].querySelector('.folder_toggler');
                toggler.addEventListener('click', function(e) {
                    toggleOpen(e.currentTarget.parentNode);
                })
            }
        }

        document.addEventListener('click', async function(e) {
            let btnNewFolder = e.target.closest('#rackoots_folder_create');
            let btnNewFolderBtn = e.target.closest('#rackoots_folder_create_btn');
            if (btnNewFolder || btnNewFolderBtn) {
                let { value: folder_name } = await Swal.fire({
                    title: translations.rackoots.folders.create.title,
                    input: 'text',
                    inputLabel: translations.rackoots.folders.create.inputLabel,
                    inputValue: null,
                    showCancelButton: true,
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    },
                    inputAttributes: {
                        maxlength: 100,
                        autocapitalize: 'off',
                        autocorrect: 'off'
                    },
                    inputValidator: (value) => {
                        if (!value) {
                            return translations.rackoots.create.errors.name;
                        }
                    }
                })
                
                if (folder_name) {
                    folder_name = strip(folder_name);
                    const tempId = genRandonString(10);
                    // Insert
                    let newFolderElement = document.getElementById('rackoots_folder_template').innerHTML;
                    newFolderElement = replaceAll(newFolderElement, {
                        '{id}': tempId,
                        '{name}': folder_name,
                    });
                    const folderCount = folders.length - 1;
                    if (folders.length > 0) {
                        folders[folderCount].insertAdjacentHTML('afterend', newFolderElement);
                    } else {
                        rootElement.insertAdjacentHTML('beforebegin', newFolderElement);
                    }

                    const newFolder = document.getElementById(tempId);
                    attachSortable(newFolder);
                    attachEventDragOver(newFolder);
                    attachEventDragLeave(newFolder);
                    attachEventDragDrop(newFolder);
                    saveFoldersOpenStatus();
    
                    // newFolder.addEventListener('click', function() {
                    //     toggleOpen(newFolder);
                    // });

                    // Create
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('name', folder_name);

                    axios.post(GlobalRoutes.rackoots.folders.create, data)
                    .then(function (response) {
                        newFolder.id = response.data.id;
                        // newFolder.removeEventListener('click');

                        const newFolderById = document.getElementById(response.data.id);
                        newFolder.addEventListener('click', function(e) {
                            toggleOpen(newFolderById);
                        });
                    })
                    .catch(function (error) {
                        new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    });
                }
            }
        });


        document.addEventListener('click',function(e) {
            let btnAllOpen = e.target.closest('#rackoots_folder_all_open');
            if (btnAllOpen) {
                toggleFolders('open')
                saveFoldersOpenStatus();
            }
        });

        document.addEventListener('click',function(e) {
            let btnAllOpen = e.target.closest('#rackoots_folder_all_close');
            if (btnAllOpen) {
                toggleFolders('close')
                saveFoldersOpenStatus();
            }
        });

        function toggleFolders(state)
        {
            let folders = document.querySelectorAll('#rackoots_nav .rackoots_folder');
            if (folders.length > 0) {
                switch (state) {
                    case 'open': 
                        for (let i = 0; i < folders.length; i++) {
                            folders[i].classList.add('open');
                        }
                    break;
                    case 'close': 
                        for (let i = 0; i < folders.length; i++) {
                            folders[i].classList.remove('open');
                        }
                    break;
                }
            }
        }

        function saveFoldersOpenStatus()
        {
            let status = {};
            let folders = document.querySelectorAll('#rackoots_nav .rackoots_folder');
            if (folders.length > 0) {
                for (let i = 0; i < folders.length; i++) {
                    let folder = folders[i];
                    status[folder.id] = folder.classList.contains('open');
                }

                setCookie('rackoot__folders_status', JSON.stringify(status), 180);
            }
        }

        // Rename
        document.addEventListener('click', function(e) {
            let btnRename = e.target.closest('.rackoots_folder_rename');
            if (btnRename) {
                renameFolder(e.target.closest('.rackoots_folder'));
            }
        });

        async function renameFolder(el) {
            const currentName = el.querySelector('.folder_toggler').innerText;
            const id = el.id;
            let { value: folder_name } = await Swal.fire({
                title: translations.rackoots.folders.rename.title,
                input: 'text',
                inputLabel: translations.rackoots.folders.create.inputLabel,
                inputValue: currentName,
                showCancelButton: true,
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                },
                inputAttributes: {
                    maxlength: 100,
                    autocapitalize: 'off',
                    autocorrect: 'off'
                },
                inputValidator: (value) => {
                    if (!value) {
                        return translations.rackoots.create.errors.name;
                    }
                }
            })
            
            if (folder_name) {
                el.querySelector('.folder_toggler').innerText = folder_name;

                // Create
                var data = new FormData();
                data.append('csrf_name', csrf_name);
                data.append('csrf_value', csrf_value);
                data.append('name', folder_name);
                data.append('folder_id', el.id);

                axios.post(GlobalRoutes.rackoots.folders.rename, data)
                .then(function (response) {
                })
                .catch(function (error) {
                    el.querySelector('.folder_toggler').innerText = currentName;
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                });
            }
        }

        // Delete
        document.addEventListener('click', function(e) {
            let btnDelete = e.target.closest('.rackoots_folder_delete');
            if (btnDelete) {
                deleteFolder(e.target.closest('.rackoots_folder'));
            }
        });

        async function deleteFolder(el) {
            Swal.fire({
                // title: translations.rackoots.folders.delete.messages.title,
                html: translations.rackoots.folders.delete.messages.body,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.rackoots.folders.delete.messages.buttonCancel,
                confirmButtonText: translations.rackoots.folders.delete.messages.buttonConfirm,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-danger ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
                if (result.value) {
                    el.classList.add('d-none');
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('folder_id', el.id);

                    axios.post(GlobalRoutes.rackoots.folders.delete, data)
                    .then(function (response) {
                    })
                    .catch(function (error) {
                        el.classList.remove('d-none');
                        new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    });

                }
            });
        }

        // Drag and drop rackoots to sort and assign to folders
        if (folders.length > 0) {
            for (let i = 0; i < folders.length; i++) {
                attachSortable(folders[i]);
                makeFoldersSortables();
            }
        }
        
        function getSortableOptions()
        {
            return {
                animation: 150,
                group: 'shared',
                ghostClass: 'ordering',
                draggable: ".rackoot__item",
                delay: 100,
                delayOnTouchOnly: true,
            }
        }

        function attachSortable(folder)
        {
            const sortable_internal = folder.querySelector('.folder__rackoots');
            if (sortable_internal !== null && sortable_internal !== 'undefined') {
                let options = getSortableOptions();
                options.store = {
                    set: function(sorted) {
                        saveSortedRackootsInFolder(folder);
                    }
                }
                const sortable = new Sortable(sortable_internal, options);
            }
        }

        function makeFoldersSortables()
        {
            const rackoots_nav = document.getElementById('rackoots_nav');
            if (rackoots_nav !== null && rackoots_nav !== 'undefined') {
                let options = {
                    animation: 150,
                    group: 'not__shared',
                    ghostClass: 'ordering',
                    draggable: ".rackoots_folder",
                    delay: 100,
                    delayOnTouchOnly: true,    
                    store: {
                        set: function(sorted) {
                            saveSortedFolders();
                        }
                    }
                };
                const sortable = new Sortable(rackoots_nav, options);
            }

        }

        function attachSortableToRoot()
        {
            const sortable_rackoots = document.getElementById('rackoots_root');
            if (sortable_rackoots !== null && sortable_rackoots !== 'undefined') {
                let options = getSortableOptions();
                options.store = {
                    set: function(sorted) {
                        saveSortedRackootsInRoot();
                    }
                }
                const sortable = new Sortable(sortable_rackoots, options);
            }
        }

        // Drag and drop into folders
        if (folders !== null) {
            for (let i = 0; i < folders.length; i++) {
                attachEventDragOver(folders[i]);
                attachEventDragLeave(folders[i]);
                attachEventDragDrop(folders[i]);
            }
        }

        function attachEventDragOver(folder)
        {
            // Drag another item over
            folder.addEventListener("dragover", function(e) {
                e.preventDefault();
                const dragged_item = document.querySelector('.rackoot__item.ordering');
                if (dragged_item == null || dragged_item == 'undefined') { return }
                folder.classList.add("drop_ready");
            }, true);
        }

        function attachEventDragLeave(folder)
        {
            // Stop drag over
            folder.addEventListener("dragleave", function(e) {
                // e.preventDefault();
                const dragged_item = document.querySelector('.rackoot__item.ordering');
                if (dragged_item == null || dragged_item == 'undefined') { return }
                folder.classList.remove("drop_ready");
            }, true);
        }

        function attachEventDragDrop(folder)
        {
            // Drop an element inside
            folder.addEventListener("drop", function(e) {
                e.preventDefault();
                const ul = folder.querySelector('ul.folder__rackoots');
                const dragged_item = document.querySelector('.rackoot__item.ordering');
                if (dragged_item == null || dragged_item == 'undefined') { return }
                folder.classList.remove("drop_ready");
                
                const destiny = e.currentTarget;
    
                if (destiny.dataset.rackootUuid == dragged_item.dataset.rackootUuid) {
                    return false;
                }
    
                //ul.appendChild(dragged_item);
    
                var data = new FormData();
                data.append('csrf_name', csrf_name);
                data.append('csrf_value', csrf_value);
                data.append('rackoot_uuid', dragged_item.dataset.rackootUuid);
                data.append('folder_id', destiny.id);
    
                axios.post(GlobalRoutes.rackoots.setFolder, data)
                .then(function (response) {
                })
                .catch(function (error) {
                    // console.log(error);
                    // new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                });
            }, true);
        }

        function attachEventDragOverToRoot()
        {
            // Drag another item over
            rootElement.addEventListener("dragover", function(e) {
                e.preventDefault();
                const dragged_item = document.querySelector('.rackoot__item.ordering');
                if (dragged_item == null || dragged_item == 'undefined') { return }
                rootElement.classList.add("drop_ready");
            }, true);
        }

        function attachEventDragLeaveToRoot()
        {
            // Stop drag over
            rootElement.addEventListener("dragleave", function(e) {
                // e.preventDefault();
                const dragged_item = document.querySelector('.rackoot__item.ordering');
                if (dragged_item == null || dragged_item == 'undefined') { return }
                rootElement.classList.remove("drop_ready");
            }, true);
        }

        function attachEventDragDropToRoot()
        {
            // Drop an element inside
            rootElement.addEventListener("drop", function(e) {
                e.preventDefault();
                const dragged_item = document.querySelector('.rackoot__item.ordering');
                if (dragged_item == null || dragged_item == 'undefined') { return }
                rootElement.classList.remove("drop_ready");

                //rootElement.appendChild(dragged_item);
    
                var data = new FormData();
                data.append('csrf_name', csrf_name);
                data.append('csrf_value', csrf_value);
                data.append('rackoot_uuid', dragged_item.dataset.rackootUuid);
                data.append('folder_id', null);
    
                axios.post(GlobalRoutes.rackoots.setFolder, data)
                .then(function (response) {
                })
                .catch(function (error) {
                    // console.log(error);
                    // new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                });
            }, true);
        }

        function saveSortedRackootsInFolder(folder)
        {
            let getSortedRackoots = folder.querySelectorAll('.rackoot__item');
            const sortedRackootsOrder = Array.prototype.map.call(getSortedRackoots, (el, index) => {
                return el.dataset.rackootUuid;
            });
            let saveSortUrl = GlobalRoutes.rackoots.reorder;
            axios.post(saveSortUrl, {csrf_name: csrf_name, csrf_value: csrf_value, order:sortedRackootsOrder})
            .then(function (response) {
                // new Toast(response.data.message, Toast.TYPE_DONE, Toast.TIME_NORMAL);
            })
            .catch(function (error) {
                new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
            });
        }

        function saveSortedRackootsInRoot()
        {
            let getSortedRackoots = document.getElementById('rackoots_root').querySelectorAll('.rackoot__item');
            if (getSortedRackoots.length > 0) {
                const sortedRackootsOrder = Array.prototype.map.call(getSortedRackoots, (el, index) => {
                    return el.dataset.rackootUuid;
                });
                let saveSortUrl = GlobalRoutes.rackoots.reorder;
                axios.post(saveSortUrl, {csrf_name: csrf_name, csrf_value: csrf_value, order:sortedRackootsOrder})
                .then(function (response) {
                    // new Toast(response.data.message, Toast.TYPE_DONE, Toast.TIME_NORMAL);
                })
                .catch(function (error) {
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                });
            }
        }

        function saveSortedFolders()
        {
            const rackoots_folders = document.getElementById('rackoots_nav').querySelectorAll('.rackoots_folder');
            if (rackoots_folders.length > 0) {
                const sortedRackootsOrder = Array.prototype.map.call(rackoots_folders, (el, index) => {
                    return el.id;
                });
                console.log(sortedRackootsOrder);
                let saveSortUrl = GlobalRoutes.rackoots.folders.reorder;
                axios.post(saveSortUrl, {csrf_name: csrf_name, csrf_value: csrf_value, order:sortedRackootsOrder})
                .then(function (response) {
                    // new Toast(response.data.message, Toast.TYPE_DONE, Toast.TIME_NORMAL);
                })
                .catch(function (error) {
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                });
            }
        }
    }
})();
